import React from "react";

const JusdgeIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.50124 0.375C7.49582 0.375 6.60124 1.00833 6.26874 1.95833H1.37624V3.54167H2.91999L0.584571 9.08333C0.212488 10.6667 1.37624 11.4583 3.3554 11.4583C5.33457 11.4583 6.56957 10.6667 6.12624 9.08333L3.79082 3.54167H6.26082C6.52207 4.21458 7.03665 4.72917 7.70957 4.99042V13.8333H0.584571V15.4167H16.4179V13.8333H9.2929V4.9825C9.96582 4.72917 10.4804 4.21458 10.7337 3.54167H13.2117L10.8762 9.08333C10.5042 10.6667 11.6679 11.4583 13.6471 11.4583C15.6262 11.4583 16.8612 10.6667 16.4179 9.08333L14.0825 3.54167H15.6262V1.95833H10.7417C10.4012 1.00833 9.50665 0.375 8.50124 0.375ZM8.50124 1.95833C8.7112 1.95833 8.91257 2.04174 9.06103 2.19021C9.2095 2.33867 9.2929 2.54004 9.2929 2.75C9.2929 2.95996 9.2095 3.16133 9.06103 3.30979C8.91257 3.45826 8.7112 3.54167 8.50124 3.54167C8.29128 3.54167 8.08991 3.45826 7.94145 3.30979C7.79298 3.16133 7.70957 2.95996 7.70957 2.75C7.70957 2.54004 7.79298 2.33867 7.94145 2.19021C8.08991 2.04174 8.29128 1.95833 8.50124 1.95833ZM3.3554 6.11458L4.5429 9.08333H2.1679L3.3554 6.11458ZM13.6471 6.11458L14.8346 9.08333H12.4596L13.6471 6.11458Z"
        fill={fill}
      />
    </svg>
  );
};

JusdgeIcon.defaultProps = {
    width: 20,
    height: 19,
    fill: "#0FAF4B",
  };
export default JusdgeIcon;
